import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SessionPopupService {
  private popupState = new BehaviorSubject<boolean>(false);
  private popupWarningState = new BehaviorSubject<boolean>(false);
  private concurrentPopupState = new BehaviorSubject<boolean>(false);
  popupState$ = this.popupState.asObservable();
  popupWarningState$ = this.popupWarningState.asObservable();
  concurrentPopup$ = this.concurrentPopupState.asObservable();
  private timer: any = null;
  sessionExpired$ = new Subject<void>();
  alreadyWarningShown: boolean = false;
  private stop$ = new Subject<void>();

  constructor(private zone: NgZone) {
    window.addEventListener('storage', event => {
      if (event.key === 'tokenExpiresIn') {
        this.startWatching();
      }
    });
  }

  startWatching() {
    const expiry = localStorage.getItem('tokenExpiresIn');
    if (!expiry) {
      return;
    }

    const expiryMs = new Date(expiry).getTime();
    const remaining = expiryMs - Date.now();

    if (remaining <= 0) {
      this.sessionExpired$.next();
      return;
    }

    this.stop$.next();

    this.alreadyWarningShown = false;

    timer(Math.max(remaining - 5 * 60_000, 0))
      .pipe(takeUntil(this.stop$))
      .subscribe(() => {
        if (!this.alreadyWarningShown) {
          this.openWarningPopup();
          this.alreadyWarningShown = true;
        }
      });

   
    timer(remaining)
      .pipe(takeUntil(this.stop$))
      .subscribe(() => {
        this.closeWarning();
        this.open();
      });
  }

  open() {
    this.popupState.next(true);
  }

  openWarningPopup() {
    this.popupWarningState.next(true);
  }

  close() {
    this.popupState.next(false);
  }

  closeWarning() {
    this.popupWarningState.next(false);
  }

  openConcurrent() {
    this.concurrentPopupState.next(true);
  }

  closeConcurrent() {
    this.concurrentPopupState.next(false);
  }
}
